var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 -50)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#30379f",
    points: "72.5 50 50 11 27.5 50 50 50"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0 50 38.5;360 50 38.5",
    keyTimes: "0;1"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#67e079",
    points: "5 89 50 89 27.5 50"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0 27.5 77.5;360 27.5 77.5",
    keyTimes: "0;1"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#67e079",
    points: "72.5 50 50 89 95 89"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0 72.5 77.5;360 72 77.5",
    keyTimes: "0;1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingState);
export default __webpack_public_path__ + "static/media/loading-state.7d56ecf02760a6273a2cd3ad3fec4656.svg";
export { ForwardRef as ReactComponent };